import store from '@/store'
import { getFriendlyErrors } from '@/functional/friendlyErrors'

export function handleMutationError(error, { operation = undefined } = {}) {
  const friendlyErrors = getFriendlyErrors(error, { operation })
  store.commit('error/add', friendlyErrors)

  throw new Error(error)
}
